/**
 * Layout breakpoints - single source of truth for responsive layout logic
 *
 * These values must match the Tailwind config breakpoints in tailwind.config.ts:
 * - desktop: 1024px (includes up to 1279px)
 * - nav-wide: 1280px
 * - wide: 1280px
 */

/** Mobile breakpoint - below this, both sidebars are overlays */
export const DESKTOP_BREAKPOINT = 1024;

/** Nav-wide breakpoint - above this, navbar center content is visible (not in sidebar) */
export const NAV_WIDE_BREAKPOINT = 1280;

/** Wide breakpoint - above this, sidebars are in-flow grid columns (for pages with panels) */
export const WIDE_BREAKPOINT = 1280;
